import { action, computed, observable, makeObservable } from 'mobx';
import { getOrderById } from '../../API/order/getOrderById';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';
import { IOrderDetailsData } from '../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export default class OrderDetailsService {
  private orderDetails: IOrderDetailsData = {
    parties: [],
    property: {
      street_address: '',
      city: '',
      state: '',
      unit: null,
      zip_code: '',
      countyName: null,
      countyState: null,
    },
    transaction: {
      id: null,
      file_number: null,
      closing_date: null,
      estimated_property_value: null,
      estimated_closing_date: null,
      purchase_price: null,
      rate_lock_expiration: null,
      external_party_transaction_id: null,
      loan_amount: null,
      loan_number: null,
      loan_type: null,
      occupancy_type: null,
      order_group_category: null,
      order_group_id: null,
      relocation_employer_name: null,
      owner_name: null,
      property_type: null,
      solar_panels: null,
      transaction_category: eTransactionCategory.Purchase,
    },
    lender: {
      id: '',
      name: '',
      bulkRateQualified: false,
      mortgageeClause: null,
    },
    client: {
      id: '',
      name: '',
      sprucePowered: false,
    },
    orderInformation: {
      created: '',
      createdBy: null,
      status: null,
      refiDiscount: null,
      fundingDate: null,
      updated: null,
      externalStatus: null,
      orderLinks: [],
    },
  };

  public initOrderDetails = async (orderId: string) => {
    try {
      const response = await getOrderById({ orderId });
      this.setOrderDetails(response as IOrderDetailsData);
      return Promise.resolve();
    } catch (e: any) {
      return Promise.reject('Error: get order information');
    }
  };

  constructor() {
    makeObservable<OrderDetailsService, 'orderDetails'>(this, {
      orderDetails: observable,
      initOrderDetails: action,
      setOrderDetails: action,
      getOrderDetails: computed,
    });
  }

  public setOrderDetails(order: IOrderDetailsData) {
    this.orderDetails = order;
  }

  public get getOrderDetails(): IOrderDetailsData {
    return this.orderDetails;
  }
}
